import React, { FC } from 'react'
import _ from 'lodash'

import { RecoveriesHover_s } from 'components/table/hovers/hover-styles'

type RecoveriesHoverProps = {
  config: {},
  data: []
}

const RecoveriesHover: FC<RecoveriesHoverProps> = (props) => {
  const { namedRecoveryItems, namedRecoveryGroupItems, prorataRecoveryItems, amtItems, detailedAmtItems, tenantMgmtFeeItems } = props.config['recoverydetail']['recoverydetail'];

  return (
    <RecoveriesHover_s>
      <div>
        <div><strong>Recovery Type</strong></div>
        <div><strong>Count</strong></div>
      </div>
      { namedRecoveryItems?.length && <div>
        <div>Named</div>
        <div>{namedRecoveryItems?.length}</div>
      </div> }
      { namedRecoveryGroupItems?.length && <div>
        <div>Recovery Groups</div>
        <div>{namedRecoveryGroupItems?.length}</div>
      </div> }
      { amtItems?.length && <div>
        <div>Amt</div>
        <div>{amtItems?.length}</div>
      </div> }
      { detailedAmtItems?.length && <div>
        <div>Detailed Amt</div>
        <div>{detailedAmtItems?.length}</div>
      </div> }
      { tenantMgmtFeeItems?.length && <div>
        <div>Tenant Mgmt Fee</div>
        <div>{tenantMgmtFeeItems?.length}</div>
      </div> }
      { prorataRecoveryItems?.length && <div>
        <div>Pro Rata</div>
        <div>{prorataRecoveryItems?.length}</div>
      </div> }
    </RecoveriesHover_s>
  )
}

export default RecoveriesHover